import http from '@/requests/http'

class Task {
  static findAll (params) {
    return http.post('task/index', params)
  }
  static store (params) {
    return http.post('task/store', params)
  }
  static view (params) {
    return http.post('task/view', params)
  }
  static update (params) {
    return http.post('task/update', params)
  }
  static destroy (params) {
    return http.post('task/destroy', params)
  }
  static settings () {
    return http.post('task/settings')
  }
}

export default Task
